(function() {
  'use strict';

  var FOCUSABLE =
    'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function getFocusableElements(container) {
    return Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE), function(el) {
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    });
  }

  function createFocusTrap(container) {
    var previousFocus = null;

    function handleKeyDown(e) {
      if (e.key !== 'Tab') return;

      var nodes = getFocusableElements(container);
      if (!nodes.length) {
        e.preventDefault();
        return;
      }

      var first = nodes[0];
      var last = nodes[nodes.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    return {
      activate: function(initialFocus) {
        previousFocus = document.activeElement;
        container.addEventListener('keydown', handleKeyDown);

        var target = initialFocus;
        if (!target || !container.contains(target)) {
          target = getFocusableElements(container)[0];
        }

        if (target) target.focus();
      },
      deactivate: function() {
        container.removeEventListener('keydown', handleKeyDown);

        if (previousFocus && typeof previousFocus.focus === 'function') {
          try {
            previousFocus.focus();
          } catch (err) {}
        }

        previousFocus = null;
      }
    };
  }

  function announceLiveRegion(id, message) {
    var el = document.getElementById(id);
    if (!el || !message) return;

    el.textContent = '';
    window.setTimeout(function() {
      el.textContent = message;
    }, 50);
  }

  function initSkipLink() {
    var skipLink = document.querySelector('[data-skip-link]');
    var main = document.getElementById('MainContent');

    if (!skipLink || !main) return;

    skipLink.addEventListener('click', function() {
      main.focus({ preventScroll: false });
    });
  }

  window.EzsportA11y = {
    createFocusTrap: createFocusTrap,
    announce: announceLiveRegion,
    initSkipLink: initSkipLink
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSkipLink);
  } else {
    initSkipLink();
  }

  async function splitCheckoutUrl({endpoint, lines, fallback, timeoutMs = 5000}) {
    try {
      const ctrl = new AbortController();
      const timer = setTimeout(() => ctrl.abort(), timeoutMs);
      let res;
      try {
        res = await fetch(endpoint, {
          method: "POST",
          headers: {"Content-Type": "application/json"},
          body: JSON.stringify({lines}),
          signal: ctrl.signal,
        });
      } finally {
        clearTimeout(timer);
      }
      if (!res.ok) { return fallback; }
      const answer = await res.json();
      return (answer && answer.ok && answer.url) ? answer.url : fallback;
    } catch (error) {
      return fallback;
    }
  }

  /**
   * One Shopify /cart.js line item, reshaped into what the Worker expects:
   * {handle, variant, qty, variant_id}. `variant` is built from the line's own
   * options_with_values, joined with " / " -- the exact separator
   * onboard/site/catalogue.py's VARIANT_SEPARATOR uses, written down a second
   * time as core.mjs's exported SEP. Shopify's own `variant_title` is NOT used
   * here: it is not guaranteed to be formatted identically, and a mismatch makes
   * known() reject every real cart silently.
   *
   * Each value is trimmed before joining, not after. catalogue.py's variant_key
   * -- which is what actually builds every key the Worker holds, both in
   * `expect` and in each host's stored map -- trims the pieces; known() only
   * trims the whole joined string, so a value carrying incidental whitespace --
   * " S " from a theme that pads its option labels -- would join into
   * " S / Black", match nothing, and have the cart refused with nothing logged.
   */
  function toSplitLine(cartItem) {
    const values = (cartItem.options_with_values || []).map(o => String(o.value).trim());
    return {
      handle: cartItem.product_handle || cartItem.handle,
      variant: values.join(" / "),
      qty: cartItem.quantity,
      variant_id: cartItem.variant_id,
    };
  }

  if (typeof module !== "undefined" && module.exports) {
    module.exports = {splitCheckoutUrl, toSplitLine};
  }
})();
